import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {MenuItem, SelectItem} from 'primeng/api';
import {BROWSERS, DeviceDetectorService} from 'ngx-device-detector';
import {ExpressDepositComponent} from '../express-deposit/express-deposit.component';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {PostalAddress} from '../../../../model/postal-address';
import {KindOfUpload} from '../helpers/kind-of-upload.enum';
import {Subject} from 'rxjs';
import {UploadedFileType} from '../helpers/file-status.enum';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {DepositDepotExpressEnum} from "../../../../enums/deposit.enums";
import {Spool} from "../../../../model/spool";
import {KindOfAcceptedFilesService} from "../../../../services/apiServices/business/kind-of-accepted-files.service";

@Component({
  selector: 'app-express-spool',
  templateUrl: './express-spool.component.html',
  styleUrls: ['./express-spool.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpressSpoolComponent implements OnInit {
  @ViewChild('addressTargetContainer', {static: false})
  addressTargetContainer: ElementRef;
  @ViewChild('addressDragContainer', {static: false})
  addressDragContainer: ElementRef;
  @Output() public modalDisplay: EventEmitter<boolean>;
  @Output() public shouldClearFiles: Subject<any>;
  public process: MenuItem[];
  public mainFile: File;
  public principalFileValidity: boolean;
  public signature: File;
  public customizedFilePdf;
  public pdfToDisplay: any;
  public currentStep: string;
  public activeIndex = 0;
  public msBrowsers: boolean;
  public hasSignature: boolean;
  public depositDir;
  public displayLoading = false;
  public progressTimeout = null;
  public persistedCount: number;
  public depositPersisted = false;
  public depositPersistedSerialLot: number = null;
  public progressPersisted = 0;
  public savingTrial = 1;
  public spoolData: PostalAddress[];
  public spoolDataValidRows: number;
  public spoolDataInValidRows: number;
  public spoolDataUnknownRows: number;
  public openVisualization: boolean;
  public FileStatus = UploadedFileType;
  public pageCount = 0;
  public sigPages: any[];
  public pages: any[];
  public pagesImages: any;
  public containerBGStyle: any;
  public targetContainerStyle: any;
  public posX: number;
  public posY: number;
  public width: number;
  public height: number;
  public cWidth: number;
  public cHeight: number;
  public selectedPage = 0;
  public spoolSplitTypes: SelectItem[];
  public selectedSpoolSplitType: string;
  public spoolSplitEveryXPages: number;
  public spoolNumberOfRecipients: number;
  public spoolSplitKeyWord: string;
  public selectedSpoolAddress: any;
  public selectedSpoolAddressLines: string[];
  public selectedSpoolAddressIndex: number;
  public showEditSpoolAddress: boolean;
  public foldCount: number;
  public spoolFileValidity: boolean;
  public selectedSpool: Spool;
  public spools: Spool[];

  constructor(private createDepositService: CreateDepositService, private translate: TranslateService,
              private commonService: CommonService, private deviceService: DeviceDetectorService, private kindOfAcceptedFilesService: KindOfAcceptedFilesService) {
    this.modalDisplay = new EventEmitter<boolean>();
    this.shouldClearFiles = new Subject<any>();
  }

  ngOnInit() {
    this.mainFile = null;
    this.msBrowsers = (BROWSERS.IE === this.deviceService.getDeviceInfo().browser || BROWSERS.MS_EDGE === this.deviceService.getDeviceInfo().browser);
    this.currentStep = ExpressDepositComponent.PARAMS_STEP;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.TEMPLATE')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.PREVIEW')},
    ];
    this.spoolSplitTypes = [
      {value: '', label: ''},
      {value: 'PAGES', label: this.translate.instant('UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_COUNT')},
      {value: 'WORD', label: this.translate.instant('UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_KEYWORD')},
      //{value: 'AREA', label: this.translate.instant('UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_ADDRESS_AREA')},
      {value: 'REGEX', label: this.translate.instant('UPLOAD_COMPONENT.EXPRESS_SPOOL_SPLIT_TYPE_REGEX_FILE')}
    ];
    this.shouldClearFiles.subscribe(clear => {
    });
    this.getSpoolsList();
  }

  public nextEnabled(): boolean {
    if (this.currentStep === ExpressDepositComponent.PARAMS_STEP) {
      return true;
    } else if (this.currentStep === ExpressDepositComponent.TEMPLATE_STEP) {
      return this.isValidRecipients();
    } else if (this.currentStep === ExpressDepositComponent.FORMATTING_STEP) {
      return true;
    } else {
      return true;
    }
  }

  validSplitOptions(): boolean {
    if (this.mainFile === null) {
      return null;
    }
    if (this.selectedSpoolSplitType === 'PAGES') {
      return this.spoolSplitEveryXPages !== null && this.spoolSplitEveryXPages > 0;
    } else if (this.selectedSpoolSplitType === 'WORD') {
      return this.spoolSplitKeyWord !== null && this.spoolSplitKeyWord.length > 0;
    } else if (this.selectedSpoolSplitType === 'AREA') {
      return this.spoolNumberOfRecipients !== null && this.spoolNumberOfRecipients > 0;
    } else if (this.selectedSpoolSplitType === 'REGEX') {
        return this.selectedSpool.name.length > 0 && this.selectedSpool.spoolId !== '_NA_';
    } else {
      return null;
    }
  }

  public setMainFile(fileType: string, files: File[]) {
    if (files && files.length === 1) {
      this.addExpressSpoolFile(files[0]);
    } else {
      this.mainFile = null;
    }
  }

  public formatAddress(address: PostalAddress): string {
    return address ? address.formatAddress() : '';
  }

  editMailingAddress(address: any, rowIndex: number) {
    this.selectedSpoolAddress = address;
    this.selectedSpoolAddressLines = address.formatted;
    this.selectedSpoolAddressIndex = rowIndex;
    setTimeout(() => {
      this.showEditSpoolAddress = true;
    }, 100);
  }

  handleDestAddressClose(event: boolean) {
    this.showEditSpoolAddress = event;
  }

  updateSpoolDataCounts() {
    this.spoolDataValidRows = 0;
    this.spoolDataInValidRows = 0;
    this.spoolDataUnknownRows = 0;
    if (this.spoolData && this.spoolData.length > 0) {
      for (const entry of this.spoolData) {
        if (entry.isValid()) {
          this.spoolDataValidRows++;
        } else {
          this.spoolDataInValidRows++;
        }
      }
      if (this.selectedSpoolSplitType === 'AREA') {
        this.spoolDataUnknownRows = this.spoolNumberOfRecipients - (this.spoolDataValidRows + this.spoolDataInValidRows);
      }
    }
  }


  removeInvalidMailingRows() {
    const tempList: PostalAddress[] = [];
    for (const entry of this.spoolData) {
      if (entry.isValid()) {
        tempList.push(entry);
      } else {
        this.spoolNumberOfRecipients--;
      }
    }
    this.spoolData = tempList;
    this.updateSpoolDataCounts();
  }

  updateSpoolAddress(address) {
    this.spoolData[this.selectedSpoolAddressIndex].formatted = address.fa;
    this.spoolData[this.selectedSpoolAddressIndex].valid = true;
    this.spoolData[this.selectedSpoolAddressIndex].fields.country = address.country;
    this.updateSpoolDataCounts();
    this.selectedSpoolAddressIndex = null;
    this.selectedSpoolAddress = null;
    this.selectedSpoolAddressLines = null;
    this.showEditSpoolAddress = false;
  }

  storeSpoolSplitInfo() {
    const splitInfo: any = {
      depositDir: this.depositDir,
      splitType: this.selectedSpoolSplitType
    };
    if (this.selectedSpoolSplitType === 'PAGES') {
      splitInfo.splitValue = this.spoolSplitEveryXPages;
    } else if (this.selectedSpoolSplitType === 'WORD') {
      splitInfo.splitValue = this.spoolSplitKeyWord;
    } else if (this.selectedSpoolSplitType === 'AREA') {
      splitInfo.splitValue = this.spoolNumberOfRecipients;
    } else if (this.selectedSpoolSplitType === 'REGEX') {
      splitInfo.splitValue = this.selectedSpool.spoolId;
    }
    splitInfo.addressArea = {
      x: this.posX * 210 / this.cWidth,
      y: this.posY * 297 / this.cHeight,
      width: this.width * 210 / this.cWidth,
      height: this.height * 297 / this.cHeight
    };
    const dataToSend = new FormData();
    dataToSend.append('splitInfo', JSON.stringify(splitInfo));
    this.createDepositService.storeSpoolSplitInfo(dataToSend).subscribe(response => {
      this.spoolData = [];
      if (response && response.depositDir && response.foldCount) {
        this.foldCount = response.foldCount;
        if (response.recipients) {
          let id = 0;
          for (const entry of response.recipients) {
            entry.id = id;
            id++;
            this.spoolData.push(new PostalAddress(entry));
          }
          this.updateSpoolDataCounts();
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  private addExpressSpoolFile(file: File) {
    const dataToSend = new FormData();
    dataToSend.append('main', file);
    dataToSend.append('depositDir', this.depositDir);
    this.createDepositService.addExpressSpoolFile(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.initSplitValue();
        this.spoolData = [];
        this.mainFile = file;
        this.pageCount = response.pageCount;
        this.sigPages = [];
        this.pages = [];
        this.pagesImages = {};
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_1'] + ')'
          };
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  public updateBG(pagination: any) {
    this.selectedPage = pagination.page + 1;
    if (this.pagesImages.hasOwnProperty('page_' + this.selectedPage)) {
      this.containerBGStyle = {
        'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedPage] + ')'
      };
    } else {
      if (this.mainFile) {
        this.createDepositService.getPageAsImage(this.depositDir, this.selectedPage).subscribe(response => {
          this.pagesImages['page_' + this.selectedPage] = response['page_' + this.selectedPage];
          this.containerBGStyle = {
            'background-image': 'url(data:image/jpeg;base64,' + this.pagesImages['page_' + this.selectedPage] + ')'
          };
        });
      }
    }
  }

  private keywordDebounceTimer: any;

  onKeywordChange() {
    // Annule le timer précédent
    if (this.keywordDebounceTimer) {
      clearTimeout(this.keywordDebounceTimer);
    }
    this.keywordDebounceTimer = setTimeout(() => {
    }, 200);
    if (this.keywordDebounceTimer) {
      clearTimeout(this.keywordDebounceTimer);
    }
    // Lance un debounce de 200 ms
    this.keywordDebounceTimer = setTimeout(() => {
      this.initAreaConfig();
    }, 200);
  }


  public initAreaConfig(): void {
    if (!this.validSplitOptions()) {
      return;
    }
    this.containerBGStyle = {
      'background-image': 'url(/assets/img/Document.jpg)'
    };
    this.posX = 100;
    this.posY = 48;
    this.width = 110;
    this.height = 47;
    this.updateBG({page: 0});
    setTimeout(() => {
      this.cWidth = this.addressDragContainer.nativeElement.clientWidth;
      this.cHeight = this.addressDragContainer.nativeElement.clientHeight;
      this.posX = this.posX * this.cWidth / 210;
      this.posY = this.posY * this.cHeight / 297;
      this.width = this.width * this.cWidth / 210;
      this.height = this.height * this.cHeight / 297;
      this.targetContainerStyle = {
        left: this.posX + 'px',
        top: this.posY + 'px',
        width: this.width + 'px',
        height: this.height + 'px'
      };
      setTimeout(() => {
        this.recalculateRegion();
      }, 100);
    }, 100);
  }

  public recalculateRegion(): void {
    this.posX = this.addressTargetContainer.nativeElement.getBoundingClientRect().left - this.addressDragContainer.nativeElement.getBoundingClientRect().left;
    this.posY = this.addressTargetContainer.nativeElement.getBoundingClientRect().top - this.addressDragContainer.nativeElement.getBoundingClientRect().top;
    this.width = this.addressTargetContainer.nativeElement.getBoundingClientRect().width;
    this.height = this.addressTargetContainer.nativeElement.getBoundingClientRect().height;
    this.cWidth = this.addressDragContainer.nativeElement.getBoundingClientRect().width;
    this.cHeight = this.addressDragContainer.nativeElement.getBoundingClientRect().height;
    // this.extractRegion();
  }

  public updateUploadValidity(fileType: string, validtyFromChild: boolean) {
    switch (fileType) {
      case UploadedFileType.MAIN:
        this.principalFileValidity = validtyFromChild;
        break;
    }
  }

  isValidRecipients() {
    if (!this.spoolData || this.spoolData.length < 1) {
      return false;
    }
    for (const add of this.spoolData) {
      if (!add.isValid()) {
        return false;
      }
      if (this.spoolDataUnknownRows !== 0) {
        return false;
      }
    }
    return true;
  }

  public nextStep() {
    switch (this.currentStep) {
      case ExpressDepositComponent.PARAMS_STEP:
        this.currentStep = ExpressDepositComponent.TEMPLATE_STEP;
        this.activeIndex++;
        break;
      case ExpressDepositComponent.TEMPLATE_STEP:
        this.storeRecipient();
        break;
      case ExpressDepositComponent.FORMATTING_STEP :
        break;
    }
  }

  public setSignatureFile(file: File) {
    this.signature = file;
    this.setSignatureFlag(file !== null);
  }

  setSignatureFlag(event: boolean) {
    this.hasSignature = event;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.TEMPLATE')}
    ];
    if (this.hasSignature) {
      this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.FORMATTING')});
    }
    this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.SPOOL.PREVIEW')});
  }

  setDepositDir(value) {
    this.depositDir = value;
  }

  storeRecipient(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    const recipients = [];
    for (const r of this.spoolData) {
      recipients.push({
        spoolFileName: r.spoolFileName,
        lines: r.formatted,
        countryISOId: r.sCountryID,
        elements: r.mElemByName
      });
    }
    dataToSend.append('recipient', JSON.stringify(recipients));
    this.createDepositService.storeRecipients(dataToSend).subscribe(response => {
      if (response.recipientCount) {
        if (this.hasSignature) {
          this.prepareSpoolSignature();
        } else {
          this.prepareSpoolFinalFile({page: 0});
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  prepareSpoolSignature(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.createDepositService.prepareSpoolSignature(dataToSend).subscribe(response => {
      if (response.pageCount) {
        this.pageCount = response.pageCount;
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
        }
        this.pages = [];
        this.sigPages = [];
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        this.currentStep = ExpressDepositComponent.FORMATTING_STEP;
        this.activeIndex++;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  signaturePositionStored(stored: boolean) {
    if (stored) {
      this.prepareSpoolFinalFile({page: 0});
    }
  }

  prepareSpoolFinalFile(pagination: any) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('foldNumber', '' + pagination.page);
    this.createDepositService.prepareSpoolFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        if (response.foldCount) {
          this.foldCount = response.foldCount;
        }
        this.customizedFilePdf = response.pdfFile;
        if (this.currentStep !== ExpressDepositComponent.REVIEW_STEP) {
          this.currentStep = ExpressDepositComponent.REVIEW_STEP;
          this.activeIndex++;
        }
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  public saveExpressDeposit(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.displayLoading = true;
    this.checkProgress(this.depositDir);
    this.createDepositService.saveExpressDeposit(dataToSend).subscribe(response => {
      this.displayLoading = false;
      clearInterval(this.progressTimeout);
      if (response.serialLotDepot) {
        this.depositPersistedSerialLot = response.serialLotDepot;
      }
      if (response.foldCount) {
        this.persistedCount = response.foldCount;
        if (this.persistedCount > 0) {
          this.depositPersisted = true;
          this.closeLoader();
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_MSG')
        });
      }
    });
  }

  checkProgress(depositDir: string) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', depositDir);
    this.progressTimeout = setInterval(() => {
      this.createDepositService.checkExpressDepositProgress(dataToSend).subscribe(response => {
        if (response.trial) {
          this.savingTrial = response.trial;
        }
        if (response.progress) {
          this.progressPersisted = response.progress;
        }
        if (response.serialLotDepot) {
          this.depositPersistedSerialLot = response.serialLotDepot;
        }
        if (response.status && (response.status === 'FINISHED' || response.status === 'FAILED' || response.status === 'NOT_FOUND')) {
          clearInterval(this.progressTimeout);
        }
      });
    }, 3000);
  }

  public loadVisualization(openModal: boolean): void {
    if (this.msBrowsers) {
      // TODO find how to preview on MS browsers
    } else {
      if (this.customizedFilePdf) {
        const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
        this.pdfToDisplay = URL.createObjectURL(blob);
        this.openVisualization = openModal;
      }
    }
  }

  closeLoader() {
    this.displayLoading = false;
    this.createDepositService.runningExpressDeposit.emit(this.depositDir);
    this.modalDisplay.emit(false);
  }

  initSplitValue() {
    this.spoolSplitKeyWord = '';
    this.spoolSplitEveryXPages = null;
    this.spoolNumberOfRecipients = null;
    /*setTimeout(() => {
      this.initAreaConfig();
    }, 100);*/
  }

  public freeDocMemory(documentToFree): void {
    window.URL.revokeObjectURL(documentToFree);
  }

  public selectSpool(): void {
    setTimeout(() => {
      this.spoolFileValidity = this.selectedSpool.spoolId !== '_NA_';
    }, 100);
  }

  processCustomerSpool(customerSpools: Spool[]) {
    this.spools = [];
    const ds = new Spool();
    ds.spoolId = '_NA_';
    ds.name = '';
    this.spools.push(ds);
    for (const spool of customerSpools) {
      this.spools.push(spool);
    }
    if (this.spools.length === 2) {
      this.selectedSpool = this.spools[1];
    } else {
      this.selectedSpool = ds;
    }
    this.spoolFileValidity = this.selectedSpool.spoolId !== '_NA_';
  }

  public getSpoolsList(): void {
    this.kindOfAcceptedFilesService.getCustomerSpoolList().subscribe(customerSpools => {
      this.processCustomerSpool(customerSpools);
    });
  }

  protected readonly DepositDepotExpressEnum = DepositDepotExpressEnum;

  updateSelectedSpool($event: any) {
    if(this.selectedSpool!= null){
      this.initAreaConfig();
    }
  }
}
